import { render, staticRenderFns } from "./MenuLateral.vue?vue&type=template&id=6f990094&scoped=true"
import script from "./MenuLateral.vue?vue&type=script&lang=js"
export * from "./MenuLateral.vue?vue&type=script&lang=js"
import style0 from "./MenuLateral.vue?vue&type=style&index=0&id=6f990094&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f990094",
  null
  
)

export default component.exports